<template>
  <div class="flex h-full">
    <el-card :class="isOpen ? 'w-600px' : 'hidden'">
      <div class="flex relative items-center justify-between">
        <div class="text-20px">关联楼层区域</div>
        <div class="absolute -left-20px -right-20px h-2px top-56px bg-gray-200"></div>
        <el-select
          v-model="currentSelectScene"
          value-key="id"
          :disabled="!loadedScene"
          @change="changeScene"
          placeholder="场景选择"
          size="small"
          filterable
        >
          <el-option
            v-for="item in modelOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </div>
      <div
        class="mt-20px"
        :class="showFloorInformation ? 'h-[calc(50%-28px)]' : 'h-[calc(100%-56px)]'"
      >
        <div class="h-full">
          <div class="flex items-center justify-between py-20px">
            <div class="flex text-18px flex items-center">
              <div class="border-l-3 border-color-primary flex-1 pl-10px text-[#303133] text-18px">
                楼层列表
              </div>
            </div>
            <div class="flex">
              <el-input
                size="small"
                v-model="filter"
                clearable
                placeholder="请输入楼层名称"
              ></el-input>
              <el-button
                :disabled="!loadedScene"
                size="small"
                class="ml-10px"
                @click="searchData"
                type="primary"
                >搜索</el-button
              >
              <el-button
                type="primary"
                :disabled="!loadedScene || isRead"
                @click="addFloor"
                size="small"
                >新增</el-button
              >
            </div>
          </div>
          <div class="h-[calc(100%-125px)]">
            <el-table
              ref="multipleTable"
              height="100%"
              class="w-full"
              @row-click="rowTbaleClick"
              :data="tableData"
              row-key="id"
              :current-row-key="currentRowKey"
              border
              highlight-current-row
              v-loading="floorListLoading"
            >
              <el-table-column
                align="center"
                prop="name"
                label="楼层名称"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                align="center"
                prop="code"
                label="楼层编码"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                align="center"
                prop="buildingName"
                label="所属建筑"
                show-overflow-tooltip
              >
              </el-table-column>
            </el-table>
          </div>
          <div class="mt-20px flex justify-end">
            <el-pagination
              small
              background
              :pager-count="5"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page.pageNo"
              :page-size="page.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="page.total"
            ></el-pagination>
          </div>
        </div>
      </div>
      <div class="mt-20px h-[calc(50%-28px)]" v-loading="detailLoading" v-if="showFloorInformation">
        <div class="flex text-18px flex items-center pb-10px border-b-gray-200 border-b-2px">
          <div class="border-l-3 border-color-primary flex-1 pl-10px text-[#303133] text-18px">
            {{ editTitle }}
          </div>
        </div>
        <div class="mt-20px h-[calc(100%-52px)] overflow-auto">
          <el-form
            ref="floorForm"
            label-width="160px"
            size="small"
            class="pr-10px"
            :model="floorForm"
            :rules="floorRules"
            :disabled="isRead"
            v-loading="isFirstPaint"
          >
            <el-form-item label="楼层名称" prop="name" class="pr-55px">
              <el-input placeholder="请输入楼层名称" v-model="floorForm.name" clearable></el-input>
            </el-form-item>
            <el-form-item label="楼层编码" prop="code" class="pr-55px">
              <el-input placeholder="请输入楼层编码" v-model="floorForm.code" clearable></el-input>
            </el-form-item>
            <el-form-item label="所属建筑" prop="buildingId" class="pr-55px">
              <el-select class="w-full" v-model="floorForm.buildingId" placeholder="请选择所属建筑">
                <el-option
                  v-for="item in buildList"
                  :key="item.id"
                  :value="item.id"
                  :label="item.name"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="关联剖切对象" prop="sectionId" class="pr-55px">
              <el-select
                ref="classfiySelectTree"
                class="w-full"
                popper-class="paint--modeltree__select"
                value-key="id"
                clearable
                filterable
                @clear="resetDeviesInfo"
                v-model="floorForm.sectionId"
                placeholder="请选择剖切对象"
              >
                <el-tree
                  :props="{
                    label: 'name',
                    children: 'children',
                  }"
                  class="text-white"
                  node-key="id"
                  highlight-current
                  :data="treeData"
                  @node-click="handleDocNodeClick($event, false)"
                  :expand-on-click-node="false"
                ></el-tree>
                <el-option
                  v-for="item in flatTreeData"
                  :key="item.id"
                  :value="item.id"
                  :label="item.name"
                  class="hidden"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="视角设置" prop="angleJson">
              <el-button
                :disabled="!loadedScene || isRead"
                type="primary"
                size="small"
                @click="saveAngle"
                >保存视角</el-button
              >
              <el-input
                class="hidden"
                placeholder="请保存视角"
                v-model="floorForm.angleJson"
                clearable
              ></el-input>
            </el-form-item>
          </el-form>
          <div class="text-center mb-20px">
            <el-button
              :disabled="!loadedScene || isRead"
              :loading="saveLoading"
              type="primary"
              @click="submitFloor"
              size="small"
              >保存</el-button
            >
            <el-button
              :disabled="!loadedScene"
              size="small"
              @click="$router.push(`${basePath}/position-backend-management/build-floor/floor-management`)"
              >返回</el-button
            >
          </div>
        </div>
      </div>
    </el-card>
    <div class="w-10px relative z-99999" :class="isOpen ? 'left-10px' : 'left-0'">
      <i
        class="absolute w-26px h-26px bg-color-primary text-white top-40px -left-10px flex items-center justify-center cursor-pointer rounded-4px"
        :class="isOpen ? 'el-icon-d-arrow-left' : 'el-icon-d-arrow-right'"
        @click="isOpen = !isOpen"
      ></i>
    </div>
    <el-card class="flex-1" style="position:relative;" :class="isOpen ? '' : '-ml-10px'">
      <model-view
        v-if="sceneDataLoad"
        :sceneOptions="sceneOptions"
        @sendPlayer="sendPlayer"
        @loadSceneEnd="loadSceneEnd"
      ></model-view>
    </el-card>
  </div>
</template>
<script>
import {
  every,
  isEmpty,
  isNil,
  cloneDeep,
  map,
  find,
  omit,
  assign,
  get,
  values,
  pick,
  head,
  eq,
  isArray,
  forEach,
  flattenDeep,
} from 'lodash'
import { ModelSceneApi, ClipApi } from '@wiz-api/scene-management'
import { FloorApi, BuildingApi } from '@wiz-api/personnel-position'
import { instance as cloudRender } from 'wiz-cloud-render-vulkan'

const clipApi = new ClipApi()
const modelSceneApi = new ModelSceneApi()
const floorApi = new FloorApi()
const buildingApi = new BuildingApi()

const ModelView = () => {
  return import('../../components/model/ModelViewVulkan')
}
export default {
  name: 'drawFloor',
  components: {
    ModelView,
  },
  data() {
    return {
      currentSelectScene: '', // 当前场景
      floorListLoading: false, // 表格加载状态
      detailLoading: false, // 表单加载状态
      loadedScene: false, // 场景是否加载完成
      isOpen: true, // 是否显示左边内容
      player: null, // 三维实例
      modelOptions: [], // 场景数据
      tableData: [], // 表格数据
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      }, // 楼层列表分页
      floorRules: {
        name: { required: true, message: '请输入楼层名称', trigger: 'blur' },
        code: { required: true, message: '请输入楼层编码', trigger: 'blur' },
        buildingId: { required: true, message: '请选择所属建筑', trigger: 'change' },
        sectionId: { required: true, message: '请选择请选择剖切对象', trigger: 'change' },
        angleJson: { required: true, message: '请保存视角', trigger: 'change' },
      }, // 楼层表单校验
      floorForm: {
        sceneId: '',
        code: '',
        name: '',
        buildingId: '',
        angleJson: '',
        coordinate: '',
        sectionId: '',
        relativeGroup: '',
      }, // 楼层表单
      buildList: [], // 显示名称列表
      filter: '',
      clickTableTimerOut: null,
      editTitle: '新增楼层',
      showFloorInformation: false, // 是否展示编辑框
      treeData: [], // 关联刨切下拉数据
      sceneOptions: {
        isEnableGis: false,
        latitude: 0,
        longitude: 0,
        name: '',
        id: '',
        sectionId: '',
        jsonData: '',
      }, // 场景加载配置项
      saveLoading: false, // 保存状态
      currentRowKey: '', // 当前高亮行
      thirdAreaList: [], // 第三方区域
      handletimer: null, // 剖切绘制定时器
      clipForm: {
        maximumLocation: { x: '', y: '', z: '' },
        minimumLocation: { x: '', y: '', z: '' },
        // 剖切方式默认为外剖切
        clipType: 1,
      },
      mat: [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1], // 单位矩阵
      clipDataType: {
        aabb: 0, // 包围盒
        node: 1, // node
        clipData: 2, // 剖切数据
      }, // 剖切类型
      clipType: {
        box: 0, // 盒子剖切
        singlePanel: 1, // 单面剖切
        doublePanel: 2, // 双面剖切
        ThreePanel: 3, // 三面剖切
      },
      isFirstPaint: true, // 当前是否为首次根据路由渲染
      sceneDataLoad: false, // 场景是否加载完成
      flatTreeData: [], // 组态树数据
    }
  },
  computed: {
    // 是否为选中状态
    isRead() {
      return this.routeInfo.operateType === 'read'
    },
    // 当前路由信息
    routeInfo() {
      return this.$route.query
    },
    // 兼容除saas其他项目使用该模块
    basePath() {
      return get(Wiz, 'globalSettings.globalConfig.routerBase') ? `/${Wiz.globalSettings.globalConfig.routerBase}` : ''
    }
  },
  async created() {
    // 获取场景列表
    await this.getSceneList()
    this.showFloorInformation = true
    // 获取刨切列表
    this.getGroupData()
    if (isEmpty(this.currentSelectScene)) {
      this.$message.warning({
        showClose: true,
        message: '楼层绑定的场景不存在',
      })
      await this.getFloorList()
      await this.getFloorDetail(this.$route.query.id)
      this.loadedScene = true
    } else {
      await this.changeScene(this.currentSelectScene)
    }
    this.sceneDataLoad = true
  },
  deactivated() {
    clearTimeout(this.handletimer)
    this.handletimer = null
    this.sceneDataLoad = false
  },
  beforeDestroy() {
    clearTimeout(this.handletimer)
    this.handletimer = null
    this.exitClip()
  },
  methods: {
    // 初始化title
    initFormTitle() {
      if (!this.routeInfo.id || !this.isFirstPaint) {
        return
      }
      this.editTitle = eq(this.routeInfo.operateType, 'update') ? '编辑建筑' : '查看建筑'
    },
    // 点击树节点
    async handleDocNodeClick(data, isClipClik = false) {
      // 点击防抖处理
      if (this.handletimer) {
        clearTimeout(this.handletimer)
        this.handletimer = null
      }
      this.handletimer = setTimeout(async () => {
        this.clipForm = this.$options.data().clipForm
        await this.getParams(data.id, data.name, isClipClik)
        this.showParams = true
        clearTimeout(this.handletimer)
        this.handletimer = null
      }, 500)
    },
    // 设置面和轴的可见性
    async setClipVisible() {
      await cloudRender.Clip.setVisible(['Axis', 'Panel'], false)
    },
    // 获取剖切参数
    async getParams(id, name, isClipClik = false) {
      const [err, res] = await clipApi.get(id)
      if (!err && !isNil(res)) {
        if (res.isEnable && res.maximumLocation && res.minimumLocation) {
          this.floorForm.sectionId = id
          this.floorForm.relativeGroup = name
          this.$refs.classfiySelectTree && this.$refs.classfiySelectTree.blur()
          this.clipForm.clipType = res.clipType
          this.clipForm.maximumLocation = JSON.parse(res.maximumLocation)
          this.clipForm.minimumLocation = JSON.parse(res.minimumLocation)
          // 展示剖切区域
          await this.showArea('aabb', isClipClik)
          return
        }
        this.$message.warning('该剖切对象未开启剖切')
        return
      }
      // 如果下一次的数据不会启用剖切则退出剖切
      this.exitClip()
    },
    // 展示剖切区域
    async showArea(type, isClipClik = false) {
      // 两种情况
      // 1.有最大坐标和最小坐标，根据包围盒剖切
      if (type === 'aabb') {
        const min = cloneDeep(this.clipForm.minimumLocation)
        const max = cloneDeep(this.clipForm.maximumLocation)
        const aabb = [
          [min.x, min.y, min.z],
          [max.x, max.y, max.z],
        ]
        // 通过包围盒的方式展示剖切盒子
        await cloudRender.Clip.createClip(this.clipDataType.aabb, this.clipType.box, {
          setIsInside: this.clipForm.clipType === 0,
          setPartCilp: false,
          aabb,
        })
        this.setClipVisible()
        // 存在楼层视角优先移动视角
        if (isClipClik && this.floorForm.angleJson) {
          this.moveToFloor()
          return
        }
        // 移动视角到包围盒
        await cloudRender.Camera.moveCamera('Aabb', aabb, 1)
      }
    },
    // 获取建筑列表
    async getBuildList() {
      this.tableLoading = true
      const data = {
        sceneId: this.currentSelectScene,
        maxResultCount: 999, // 每页多少条
        skipCount: 0, // 跳过多少条
      }
      const [err, res] = await buildingApi.getList(data)
      if (!err) {
        this.buildList = res.items
      }
    },
    // 扁平化模型树
    transformList(data, resultList = []) {
      if (!isArray(data)) {
        return []
      }
      forEach(data, (node) => {
        resultList.push(pick(node, ['id', 'name']))
        this.transformList(node.children, resultList)
      })
      return resultList
    },
    // 清空筛选
    resetDeviesInfo() {
      this.floorForm.sectionId = ''
      this.floorForm.relativeGroup = ''
      this.exitClip()
    },
    // 退出刨切
    exitClip() {
      cloudRender.Clip && cloudRender.Clip.cancelClip()
    },
    // 获取场景列表
    async getSceneList() {
      const [err, res] = await modelSceneApi.getList({
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err && !isNil(res)) {
        this.modelOptions = res.items
        this.currentSelectScene =
          get(find(this.modelOptions, ['id', this.routeInfo.sceneId]), 'id') ||
          head(this.modelOptions)?.id
      }
    },
    // 获取场景详情
    async getSceneDetail(id) {
      const [err, res] = await modelSceneApi.get(id)
      let options = null
      if (!err && !isNil(res)) {
        options = pick(res, ['isEnableGis', 'latitude', 'longitude', 'name', 'id', 'sectionId'])
      }
      const [jsonErr, jsonRes] = await modelSceneApi.getModelSecenRelatedJson({ id })
      if (!jsonErr) {
        options.jsonData = jsonRes
      }
      if (isEmpty(jsonRes)) {
        this.$message({
          showClose: true,
          message: '当前场景没有模型，不可绘制楼层',
          type: 'warning',
        })
        this.loadedScene = true
        if (this.isFirstPaint && this.$route.query.id) {
          await this.getFloorDetail(this.$route.query.id)
          this.isFirstPaint = false
        }
      }
      this.sceneOptions = cloneDeep(options)
    },
    // 保存当前相机视角
    async saveAngle() {
      const cameraInfo = await cloudRender.Camera.getCurrentCamera()
      if (cameraInfo) {
        this.floorForm.angleJson = JSON.stringify(cameraInfo.data)
        this.$message({
          showClose: true,
          message: '保存视角成功',
          type: 'success',
        })
      }
    },
    // 监听场景加载完成
    async loadSceneEnd() {
      this.loadedScene = true
      if (
        this.routeInfo.operateType &&
        this.routeInfo.id &&
        eq(this.routeInfo.sceneId, this.currentSelectScene) &&
        this.isFirstPaint
      ) {
        this.editTitle = this.routeInfo.operateType === 'update' ? '编辑楼层' : '查看楼层'
        await this.getFloorDetail(this.routeInfo.id)
        return
      }
      this.isFirstPaint = false
    },
    // 搜索
    resetSearchData() {
      this.filter = this.$options.data().filter
      this.searchData()
    },
    // 搜索
    searchData() {
      this.page.pageNo = 1
      this.getFloorList()
    },
    // 获取刨切树
    async getGroupData() {
      // 获取剖切树结构
      this.treeLoading = true
      const [err, res] = await clipApi.menuPageQueryList({
        sceneId: this.currentSelectScene,
        isQueryAsTree: true,
      })
      this.treeLoading = false
      if (!err && !isNil(res)) {
        this.treeData = res.items
        this.flatTreeData = this.transformList(res.items)
      }
    },
    // 新增楼层
    async addFloor() {
      this.showFloorInformation = true
      this.editTitle = '新增楼层'
      this.initFormTitle()
      this.floorForm.type = []
      this.$nextTick(() => {
        this.$refs.floorForm && this.$refs.floorForm.resetFields()
      })
      this.exitClip()
      this.floorForm = this.$options.data().floorForm
    },
    // 切换场景
    async changeScene(id) {
      this.loadedScene = false
      if (this.isRead && !this.isFirstPaint) {
        this.showFloorInformation = false
        this.exitClip()
      } else {
        // 打开新增弹框
        this.addFloor()
      }
      // 获取场景下所有楼栋
      this.getBuildList()
      // 获取绘制当前选择场景信息
      await this.getSceneDetail(id)
      // 重置当前场景楼层列表
      this.resetSearchData()
      // 获取当前场景刨切
      this.getGroupData()
    },
    // 表格row点击事件
    async rowTbaleClick(val) {
      if (!this.loadedScene) {
        this.$message.warning('请等场景加载完成后操作')
      }
      this.editTitle = eq(this.routeInfo.operateType, 'update') ? '编辑楼层' : '查看楼层'
      this.showFloorInformation = true
      this.currentRowKey = val.id
      this.floorForm = {
        ...val,
      }
      this.$refs.floorForm && this.$refs.floorForm.clearValidate()
      this.handleDocNodeClick({ id: val.sectionId, name: val.sectionName }, true)
    },
    // 点击定位到楼层位置
    async moveToFloor() {
      if (this.clickTableTimerOut) clearTimeout(this.clickTableTimerOut)
      this.clickTableTimerOut = setTimeout(async () => {
        if (this.floorForm && this.floorForm.angleJson) {
          cloudRender.Camera.moveCamera('CameraParam', this.floorForm.angleJson)
        }
      }, 500)
    },
    // 存储实例化完成的player
    async sendPlayer(player) {
      this.player = player
    },
    // 提交表单
    submitFloor() {
      this.$refs.floorForm.validate(async (value) => {
        if (value) {
          this.saveLoading = true
          const params = assign(
            omit(this.floorForm, ['points', !this.floorForm.sectionId ? 'sectionId' : '']),
            {
              sceneId: this.currentSelectScene,
            }
          )
          // 存在id为编辑
          if (!params.id) {
            const [err, res] = await floorApi.create({
              body: params,
            })
            this.saveLoading = false
            if (err) {
              return
            }
            this.floorForm = this.$options.data().floorForm
            this.$refs.floorForm.resetFields()
            this.exitClip()
          } else {
            const [err, res] = await floorApi.update(params.id, {
              body: params,
            })
            this.saveLoading = false
            if (err) {
              return
            }
          }
          await this.getFloorList()
          this.$message({
            showClose: true,
            message: `${params.id ? '修改' : '新增'}成功`,
            type: 'success',
          })
        }
      })
    },
    handleSizeChange(val) {
      this.page.pageSize = val
      this.getFloorList()
    },
    handleCurrentChange(val) {
      this.page.pageNo = val
      this.getFloorList()
    },
    // 获取楼层列表
    async getFloorList() {
      this.floorListLoading = true
      const params = {
        sceneId: this.currentSelectScene,
        filter: this.filter,
        skipCount: (this.page.pageNo - 1) * this.page.pageSize,
        maxResultCount: this.page.pageSize,
      }
      // 获取分页列表
      const [err, res] = await floorApi.getList(params)
      if (!err && res) {
        this.tableData = res.items
        this.page.total = res.totalCount
        this.$nextTick(() => {
          this.$refs.floorForm && this.$refs.multipleTable.doLayout()
        })
      }
      this.floorListLoading = false
    },
    // 获取楼层详情
    async getFloorDetail(id) {
      this.detailLoading = true
      const [err, res] = await floorApi.get(id)
      this.isFirstPaint = false
      this.detailLoading = false
      if (!err && res) {
        this.floorForm = res
        // 初始化表格高亮
        if (!this.currentRowKey) {
          this.currentRowKey = this.floorForm.id
        }
        this.handleDocNodeClick({ id: res.sectionId, name: res.sectionName }, true)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .el-card__body {
    height: 100%;
  }
}
</style>

<style lang="scss">
.paint--modeltree__select {
  min-height: 150px;
  max-height: 300px;
  .el-select-dropdown__empty {
    transform: translateY(100%);
  }
}
</style>
